import {Tile} from "./Tile";
import * as PropTypes from "prop-types";

PatternLine.propsTypes = {
    shift: PropTypes.number,
    pattern_lenght: PropTypes.number,
    size: PropTypes.number,
    tiles: PropTypes.array,
    opacity: PropTypes.number,
    onTileClick: PropTypes.func,
    colors: PropTypes.array,
    editable: PropTypes.bool,
}

export function PatternLine(props) {
    let k = 0;
    let tiles = [];
    for (let i = 0; i < props.pattern_lenght; i++) {
        tiles.push(
            <Tile
                key={k++}
                size={props.size}
                color={props.tiles[i]}
                onTileClick={(e) => {
                    e.preventDefault()
                    props.onTileClick(e.type === 'click' ? 1 : 0 ,i)
                }}
                colors={props.colors}
                editable={props.editable}
            />
        );
    }
    return (
        <div className="pattern-line" style={{height: props.size + 1, marginLeft: props.size * props.shift}}>
            {tiles}
        </div>
    );
}